export default "__VITE_ASSET__CImxLWnd__"